// extracted by mini-css-extract-plugin
module.exports =  {"root":"tVuROzx2HGQ7nSE9PJ9w","header":"y0oaJa0KV95Kho5VHxkx","count":"b7YAth2UxE2AJhE29k_o","label":"BB__J5ODftAFGrViXRyA"};